import { Component } from '@theme/component';
import { getStore, formatMoney, isColourOption } from '@theme/it-pdp-store';

/**
 * IT PDP — mobile sticky buy bar.
 *
 * A mirror, not a second buy path: the price and label come from the store,
 * and the press is forwarded to the IT · Add to bag block so the missing
 * option nudge and the cart submission stay in one place.
 */
class ItPdpStickyBar extends Component {
  requiredRefs = ['cta', 'label', 'now'];

  #unsubscribe;

  connectedCallback() {
    super.connectedCallback();

    this.#root = this.closest('[data-it-pdp]') ?? document;
    this.refs.cta.addEventListener('click', this.#onClick);
    this.refs.buyNow?.addEventListener('click', this.#onBuyNow);

    const store = getStore(this);
    if (!store) return;

    const productSoldOut = this.dataset.productSoldOut === 'true';

    this.#unsubscribe = store.subscribe(({ variant, complete, moneyFormat, prompt }) => {
      const soldOut = productSoldOut || (complete && (!variant || !variant.available));
      // Mirror of the in-flow CTA: ask for the option the store says is next.
      const selectLabel =
        !complete && isColourOption(prompt)
          ? this.dataset.labelSelectColor || this.dataset.labelSelect
          : this.dataset.labelSelect;

      if (this.refs.buyNow) this.refs.buyNow.disabled = !complete || soldOut;

      // Sold out - the whole style or the chosen size - reads "Notify me":
      // the press is forwarded to the buy block, which opens Cartbite's form.
      this.refs.label.textContent = soldOut
        ? this.dataset.labelNotify
        : !complete
        ? selectLabel
        : this.dataset.labelAdd;

      if (!variant) return;

      this.refs.now.textContent = formatMoney(variant.price, moneyFormat);

      if (this.refs.was) {
        const onSale = variant.compareAtPrice > variant.price && variant.price > 0;
        this.refs.was.textContent = formatMoney(variant.compareAtPrice, moneyFormat);
        this.refs.was.hidden = !onSale;
      }
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#unsubscribe?.();
  }

  #root = null;

  #onClick = () => {
    this.#root.dispatchEvent(new CustomEvent('it:request-add-to-cart', { bubbles: true, detail: {} }));
  };

  #onBuyNow = () => {
    this.#root.dispatchEvent(new CustomEvent('it:request-buy-now', { bubbles: true, detail: {} }));
  };
}

if (!customElements.get('it-pdp-sticky-bar')) {
  customElements.define('it-pdp-sticky-bar', ItPdpStickyBar);
}
